import { List, Map } from 'immutable';

import { FIND, OPERATIONS, REPLACE } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { VALUE } from '../../../../constants/product';
import { EBAY, FAIRE } from '../../../../constants/channels';

export function sku({ channel, preview }) {
  const operation = preview.getIn([ATTRIBUTE.SKU, 'operation']);

  switch (channel) {
    case EBAY:
    case FAIRE: {
      return {
        payload: Map({
          type: operation,
          value: operation === OPERATIONS[channel].SKU.FIND_AND_REPLACE
            ? Map({
              find: preview.getIn([ATTRIBUTE.SKU, FIND]),
              replace: preview.getIn([ATTRIBUTE.SKU, REPLACE]),
            })
            : preview.getIn([ATTRIBUTE.SKU, VALUE]),
        }),
      };
    }

    default: {
      return {
        payload: Map({
          type: operation,
          value: List([
            Map({
              combination: null,
              offeringId: null,
              value: operation === OPERATIONS[channel].SKU.FIND_AND_REPLACE
                ? Map({
                  find: preview.getIn([ATTRIBUTE.SKU, FIND]),
                  replace: preview.getIn([ATTRIBUTE.SKU, REPLACE]),
                })
                : preview.getIn([ATTRIBUTE.SKU, VALUE]),
            }),
          ]),
        }),
      };
    }
  }
}
